import { ADD_STATE_PAY_IN_META, DELETE_STATE_PAY_IN_META, GET_AVAILABLE_STATE_PAYMENT_META, GET_MERCHANT_STATE_PAY_IN_META, GET_STATE_PAY_IN_META, UPDATE_STATE_PAY_IN_META_DAILY_LIMIT, UPDATE_STATE_PAY_IN_META_LEVEL, UPDATE_STATE_PAY_IN_META_MAX_LIMIT, UPDATE_STATE_PAY_IN_META_METHOD, UPDATE_STATE_PAY_IN_META_MIN_LIMIT, UPDATE_STATE_PAY_IN_META_PER_LIMIT, UPDATE_STATE_PAY_IN_META_STATUS } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const State_pay_in_meta = (payload) => {
    return apiInstance.post(GET_STATE_PAY_IN_META, payload);
};

export const Merchant_state_pay_in_meta = (payload) => {
    return apiInstance.post(GET_MERCHANT_STATE_PAY_IN_META, payload);
};

export const Get_Available_State_Payment_Meta = (payload) => {
    return apiInstance.post(GET_AVAILABLE_STATE_PAYMENT_META, payload);
};

export const Add_State_Pay_In_Meta = (payload) => {
    return apiInstance.post(ADD_STATE_PAY_IN_META, payload);
};

export const Update_State_Pay_In_Meta_Method = (payload) => {
    return apiInstance.post(UPDATE_STATE_PAY_IN_META_METHOD, payload);
};

export const Update_State_Pay_In_Meta_Level = (payload) => {
    return apiInstance.post(UPDATE_STATE_PAY_IN_META_LEVEL, payload);
};

export const Update_State_Pay_In_Meta_Status = (payload) => {
    return apiInstance.post(UPDATE_STATE_PAY_IN_META_STATUS, payload);
};

export const Update_State_Pay_In_Meta_Min_Limit = (payload) => {
    return apiInstance.post(UPDATE_STATE_PAY_IN_META_MIN_LIMIT, payload);
};

export const Update_State_Pay_In_Meta_Max_Limit = (payload) => {
    return apiInstance.post(UPDATE_STATE_PAY_IN_META_MAX_LIMIT, payload);
};

export const Update_State_Pay_In_Meta_Daily_Limit = (payload) => {
    return apiInstance.post(UPDATE_STATE_PAY_IN_META_DAILY_LIMIT, payload);
};

export const Update_State_Pay_In_Meta_Per_Limit = (payload) => {
    return apiInstance.post(UPDATE_STATE_PAY_IN_META_PER_LIMIT, payload);
};

export const Delete_State_Pay_In_Meta = (payload) => {
    return apiInstance.post(DELETE_STATE_PAY_IN_META, payload);
};
